import React, { useEffect } from 'react';
import { HiX } from 'react-icons/hi';
import { HiExclamationTriangle } from 'react-icons/hi2';


const GhostModeWarningModal = ({ isOpen, onConfirm, onCancel, targetUser }) => {
  useEffect(() => {
    if (!isOpen) return undefined;
    const handleKeyDown = (event) => {
      if (event.key === 'Escape') onCancel();
    };
    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [isOpen, onCancel]);

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[9999] overflow-y-auto" role="dialog" aria-modal="true" aria-labelledby="ghost-mode-warning-title">
      <div className="flex items-center justify-center min-h-screen px-4 pt-4 pb-20 text-center sm:block sm:p-0">
        <div className="fixed inset-0 transition-opacity bg-gray-500 bg-opacity-75" onClick={onCancel}></div>

        <span className="hidden sm:inline-block sm:align-middle sm:h-screen">&#8203;</span>

        <div className="inline-block align-bottom bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full sm:p-6">
          <div className="absolute top-0 right-0 pt-4 pr-4">
            <button
              onClick={onCancel}
              aria-label="Close"
              className="bg-white rounded-md text-gray-400 hover:text-gray-500 focus:outline-none"
            >
              <HiX className="h-6 w-6" />
            </button>
          </div>

          <div className="sm:flex sm:items-start">
            <div className="mx-auto flex-shrink-0 flex items-center justify-center h-12 w-12 rounded-full bg-yellow-100 sm:mx-0 sm:h-10 sm:w-10">
              <HiExclamationTriangle className="h-6 w-6 text-yellow-600" />
            </div>
            <div className="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
              <h3 id="ghost-mode-warning-title" className="text-lg leading-6 font-medium text-gray-900">
                Enter Ghost Mode
              </h3>
              <div className="mt-2">
                <p className="text-sm text-gray-500">
                  You are about to impersonate the following user:
                </p>
                <div className="mt-3 p-3 bg-gray-50 rounded-md">
                  <p className="text-sm font-medium text-gray-900">
                    {targetUser?.name || 'Unknown User'}
                  </p>
                  <p className="text-xs text-gray-500">
                    {targetUser?.email}
                  </p>
                </div>
                <div className="mt-3 space-y-2">
                  <p className="text-sm text-gray-700 font-medium">
                    Important:
                  </p>
                  <ul className="list-disc list-inside text-xs text-gray-600 space-y-1">
                    <li>You will see the application as this user sees it</li>
                    <li>All actions will be performed as this user</li>
                    <li>This session will be logged for audit purposes</li>                    
                    <li>You can exit ghost mode at any time</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>

          <div className="mt-5 sm:mt-4 sm:flex sm:flex-row-reverse gap-3">
            <button
              onClick={onConfirm}
              className="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-canvas-primary text-base font-medium text-white hover:bg-opacity-90 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-canvas-primary sm:ml-3 sm:w-auto sm:text-sm"
            >
              Continue
            </button>
            <button
              onClick={onCancel}
              className="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500 sm:mt-0 sm:w-auto sm:text-sm"
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GhostModeWarningModal;
